import { CONFIGURATION_TAB_MESSAGES, ConfigurationTabMessages } from "./configuration-tab.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { ADRESS_MESSAGES, AddressMessages } from "../address.messages";
import { DOCUMENT_MESSAGES, DocumentMessages } from "../document-messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { PHONE_MESSAGES, PhoneMessages } from "../phone-messages";

export type CustomerFormMessages = SidebarMessages &
  AddressMessages &
  PhoneMessages &
  DocumentMessages &
  ConfigurationTabMessages &
  ActionButtonMessages & {
    errorRequiredStatus: string;
    errorRequiredCode: string;
    errorRequiredFantasy: string;
    errorRequiredNameUser: string;
    errorRequiredName: string;
    errorRequiredFederalTaxId: string;
    errorRequiredStateTaxId: string;
    errorRequiredCityTaxId: string;
    errorRequiredAddress: string;
    errorRequiredAddressNumber: string;
    errorRequiredDistrict: string;
    errorRequiredCity: string;
    errorRequiredState: string;
    errorRequiredCountry: string;
    errorRequiredZipCode: string;
    errorRequiredAddressComp: string;
    cepNotFoundError: string;
    errorCodeTooShort: string;

    errorInvalidEmail: string;
    errorRequiredEmail: string;
    errorInvalidPhone: string;
    errorRequiredPhone: string;
    invalidCPF: string;
    invalidCNPJ: string;

    activeOption: string;
    inactiveOption: string;
    waitingForEmailConfirmationOption: string;

    statusLabel: string;
    stateUfLabel: string;
    codeLabel: string;
    fantasyLabel: string;
    nameLabel: string;
    federalTaxIdLabel: string;
    stateTaxIdLabel: string;
    cityTaxIdLabel: string;
    addressLabel: string;
    addressNumberLabel: string;
    addressCompLabel: string;
    districtLabel: string;
    cityLabel: string;
    stateLabel: string;
    countryLabel: string;
    zipCodeLabel: string;
    phone1Label: string;
    phone2Label: string;
    mobilePhoneLabel: string;

    emailLabel: string;
    documentTypeLabel: string;
    personTypeLabel: string;
    logoCompanyLabel: string;
    descriptionLabel: string;
    descriptionPlaceholder: string;

    // Messages for buttons
    updateCustomerButton: string;
    createCustomerButton: string;
    createButton: string;
    createNewAccount: string;

    // Messages for CRUD actions
    updateCustomerError: string;
    updateCustomerSuccess: string;
    createCustomerError: string;
    createCustomerSuccess: string;

    // Error messages
    errorToLoad: string;
    notFoundAlt: string;
    notFoundError: string;
    noImageSelected: string;

    // Titles
    updateCustomerPageTitle: string;
    logoTitle: string;

    // Sections
    addressSection: string;
    logoSection: string;
    contactSection: string;
    generalSection: string;
    taxSection: string;

    //Dialog messages
    removeLogoDialogTitle: string;
    descriptionDialog: string;

    //Button messages
    updateImgButton: string;
    addImageLabel: string;

    noOptionsText: string;
  };

// Customer form messages
export const CUSTOMER_FORM_MESSAGES: CustomerFormMessages = {
  // Error messages for required fields
  errorRequiredStatus: "Por favor, selecione um status",
  errorRequiredCode: "Por favor, insira um código",
  errorRequiredFantasy: "Por favor, insira uma fantasia",
  errorRequiredNameUser: "Por favor, insira uma nome",
  errorRequiredName: "Por favor, insira um nome",
  errorRequiredFederalTaxId: "Por favor, insira um CNPJ/CPF",
  errorRequiredStateTaxId: "Por favor, insira um Inscrição Estadual",
  errorRequiredCityTaxId: "Por favor, insira um Inscrição Municipal",
  errorRequiredAddress: "Por favor, insira um endereço",
  errorRequiredAddressNumber: "Por favor, insira o número do endereço",
  errorRequiredDistrict: "Por favor, insira um bairro",
  errorRequiredCity: "Por favor, insira uma cidade",
  errorRequiredState: "Por favor, insira um estado",
  errorRequiredCountry: "Por favor, selecione um país",
  errorRequiredZipCode: "Por favor, insira um CEP",
  errorRequiredAddressComp: "Por favor, o complemento",

  // Error messages for field validation
  errorInvalidEmail: "Email inválido",
  errorRequiredEmail: "Por favor, insira um email",
  errorInvalidPhone: "Telefone inválido",
  errorRequiredPhone: "Por favor, insira um telefone",
  cepNotFoundError: "Cep não encontrado",
  errorCodeTooShort: "O código digitado deve conter pelo menos 10 caracteres",
  invalidCPF: "Digite um CPF válido",
  invalidCNPJ: "Digite um CNPJ válido",

  // Options
  activeOption: "Ativo",
  inactiveOption: "Inativo",
  waitingForEmailConfirmationOption: "Aguardando confirmação de e-mail",

  // Labels for form fields
  statusLabel: "Status",
  stateUfLabel: "UF",
  codeLabel: "Código",
  fantasyLabel: "Fantasia",
  nameLabel: "Nome",
  federalTaxIdLabel: "CNPJ/CPF",
  stateTaxIdLabel: "Inscrição Estadual",
  cityTaxIdLabel: "Inscrição Municipal",
  addressLabel: "Endereço",
  addressNumberLabel: "Número",
  addressCompLabel: "Complemento",
  districtLabel: "Bairro",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  countryLabel: "País",
  zipCodeLabel: "CEP",
  phone1Label: "Telefone",
  mobilePhoneLabel: "Celular",
  phone2Label: "Telefone 2",
  emailLabel: "Email",
  documentTypeLabel: "Tipo de documento",
  personTypeLabel: "Tipo de Pessoa",
  logoCompanyLabel: "Adicionar logo",
  descriptionLabel: "Descrição da Empresa",
  descriptionPlaceholder: "Escreva um pouco sobre a empresa...",

  // Messages for buttons
  updateCustomerButton: "Editar Empresa",
  createCustomerButton: "Criar Empresa",
  createButton: "Criar",
  createNewAccount: "Nova conta",

  // Messages for CRUD actions

  updateCustomerError: "Erro ao Editar empresa. Por favor, tente novamente.",
  updateCustomerSuccess: "Empresa atualizada com sucesso!",
  createCustomerError: "Erro ao criar empresa. Por favor, tente novamente.",
  createCustomerSuccess: "Empresa criada com sucesso!",

  // Error messages
  errorToLoad: "Erro ao carregar informações da empresa.",
  notFoundAlt: "Empresa não encontrada.",
  notFoundError: "Empresa não encontrada",
  noImageSelected: "Clique para escolher uma imagem",

  // Titles
  updateCustomerPageTitle: "Editar Empresa",
  logoTitle: "Logo",

  //Dialog messages
  removeLogoDialogTitle: "Remover Logo",
  descriptionDialog: "Tem certeza de que deseja remover o logo? Esta ação não pode ser desfeita.",
  // Sections
  addressSection: "Endereço",
  logoSection: "Logo",
  contactSection: "Contatos",
  generalSection: "Informações Gerais",
  taxSection: "Informações Tributárias",

  updateImgButton: "Atualizar",
  addImageLabel: "Faça upload",

  noOptionsText: "Nenhuma opção disponível",

  ...CONFIGURATION_TAB_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...DOCUMENT_MESSAGES,
  ...PHONE_MESSAGES,
  ...ADRESS_MESSAGES,
};
